
























import { Component, Vue, Prop, Provide, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { IDevice } from "../../models/interfaces/device/device.model.interface";
import container from "../../inversify.config";
import Loader from "@/components/Loader.vue";
import { IContentSet } from "../../models/interfaces/content/content-set.model.interface";
import { IContentSetDevice } from "../../models/interfaces/content/content-set-device.model.interface";

const DeviceModule = namespace("deviceModule");
const ContentSetModule = namespace("contentSetModule");

@Component({
  components: {
    Loader
  }
})
export default class ContentSetDevices extends Vue {
  @DeviceModule.Action public getDevices;
  @DeviceModule.Getter public devices;
  @ContentSetModule.Action public addContentSetDevice;
  @ContentSetModule.Action public removeContentSetDevice;

  @Prop() public contentSet: IContentSet;
  @Prop() public loading: boolean;

  @Provide() public items: IContentSetDevice[] = [];

  private internalLoading: boolean = false;

  get loadingStatus(): boolean {
    return this.loading || this.internalLoading;
  }

  @Watch("getContentSet", { deep: true })
  public onContentSetUpdate() {
    this.updateDevices();
  }

  get getContentSet(): IContentSet {
    return this.contentSet;
  }

  public updateDevices() {
    this.internalLoading = true;
    if (this.getContentSet.contentSetId > 0) {
      this.getDevices().then((result) => {
        this.items = this.filterDevices(this.devices);
        this.internalLoading = false;
      });
    }
  }

  public toggleDevice(device: IContentSetDevice) {
    if (device.selected) {
      this.removeContentSetDevice(device.device);
    } else {
      this.addContentSetDevice(device.device);
    }
  }

  public filterDevices(devices: IDevice[]): IContentSetDevice[] {
    const selectedDevices = this.contentSet.devices.map((x) => x.deviceTypeId);
    const contentSetDevices: IContentSetDevice[] = [];

    devices.forEach((device) => {
      contentSetDevices.push({
        selected: selectedDevices.includes(device.deviceTypeId),
        device
      });
    });

    return contentSetDevices;
  }

  public getDeviceImage(contentSetDevice: IContentSetDevice): string {
    if (contentSetDevice.selected) {
      return contentSetDevice.device.deviceTypeId + "-active.svg";
    }
    return contentSetDevice.device.deviceTypeId + ".svg";
  }

  public created() {
    this.updateDevices();
  }
}
